// @ts-strict-ignore
import ProductsSlider from '@components/product-slider'
import { useArticlesByIdQuery } from '@generated'
import { useEmarsysFeaturedProducts } from '@lib/use-emarsys-store'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

const EmarsysHomeFeaturedProducts: FC = () => {
  const featuredProducts = useEmarsysFeaturedProducts()
  const { t } = useTranslation('other')
  const [{ fetching, data }] = useArticlesByIdQuery({
    variables: { ids: featuredProducts },
    pause: !featuredProducts,
  })

  return (
    <ProductsSlider
      emarsysContainerId="featured-products-home"
      isLoading={fetching || !featuredProducts}
      title={t('featuredProducts')}
      articles={data && data.articlesById}
    />
  )
}

export default EmarsysHomeFeaturedProducts
